var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',_vm._b({ref:"form",on:{"submit":function($event){$event.preventDefault();$event.stopPropagation();return _vm.submit.apply(null, arguments)}},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'v-form',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }